import { createSelector } from 'reselect'
import type { ClientLibrary, ClientLibraryId } from 'types/client-library'
import type { State } from 'types/redux'
import { isArtistProfileCatalog } from '@disco/utils/isArtistProfile'

const getClientLibraryItems = (
  state: State,
): Record<ClientLibraryId, ClientLibrary> =>
  state.clientLibraries.libraries.items

/**
 * Gets the first client library with an artist profile catalog type.
 * @param state - The Redux state
 * @returns The artist profile client library, or null if none exists
 */
export const getArtistProfile = createSelector(
  [getClientLibraryItems],
  (clientLibraryItems): ClientLibrary | null =>
    Object.values(clientLibraryItems).find(isArtistProfileCatalog) ?? null,
)
